import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M56.4401 1.92004L31.2201 1.98999L5.99011 1.92004C5.99011 1.92004 5.66011 6.87004 2.36011 6.79004C2.36011 6.79004 4.0101 10.0899 7.7301 9.42993C7.7301 9.42993 6.49011 15.87 12.8501 15.62H28.8701H33.5801H49.6001C55.9601 15.87 54.7201 9.42993 54.7201 9.42993C58.4401 10.0899 60.0901 6.79004 60.0901 6.79004C56.7701 6.88004 56.4401 1.92004 56.4401 1.92004Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
